import { useEffect } from 'react';

/** タブの見出しに付ける印（U6）。別のタブを見ていても回答待ちに気づけるようにする。 */
export const WAITING_TITLE_PREFIX = '【回答待ち】';

/** waiting の間だけ document.title の先頭に印を付け、外れたら元の見出しに戻す。 */
export function useWaitingTitle(waiting: boolean): void {
  useEffect(() => {
    if (!waiting) return;
    const original = document.title;
    if (!original.startsWith(WAITING_TITLE_PREFIX)) document.title = `${WAITING_TITLE_PREFIX}${original}`;
    return () => {
      document.title = original;
    };
  }, [waiting]);
}
